// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Question: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 34 34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17 .3C7.8.3.3 7.8.3 17S7.8 33.7 17 33.7 33.7 26.2 33.7 17 26.2.3 17 .3zm1.7 28.4h-3.3v-3.3h3.3v3.3zm3.4-13l-1.5 1.5c-1.2 1.2-1.9 2.2-1.9 4.7h-3.3v-.8c0-1.8.8-3.5 1.9-4.7l2.1-2.1c.6-.6 1-1.4 1-2.3 0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3h-3.3a6.7 6.7 0 0113.4 0c-.2 1.5-.8 2.8-1.8 3.7z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(Question);
